var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isUploaderSetting
    ? _c(
        "div",
        [
          _c("q-uploader", {
            ref: "table-upload",
            staticClass: "table-upload",
            style: _vm.maxheight,
            attrs: {
              flat: "",
              bordered: "",
              "with-credentials": "",
              capture: "environment",
              "field-name": "file",
              url: _vm.url,
              headers: _vm.headers,
              method: "POST",
              label: _vm.label,
              "form-fields": _vm.formFields,
              "auto-upload": true,
              "hide-upload-btn": true,
              multiple: _vm.setting.multipleSelFlag === "Y",
              accept: _vm.setting.acceptExt,
              "max-file-size": _vm.setting.limitSize * 1000000,
              "max-total-size":
                _vm.setting.limitSize * 1000000 * _vm.setting.limitCnt,
              "max-files": _vm.maxFiles,
              "no-thumbnails": _vm.setting.previewFlag === "Y",
              disable: !_vm.editable,
            },
            on: {
              finish: _vm.finish,
              uploaded: _vm.uploaded,
              failed: _vm.failed,
              rejected: _vm.rejected,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "row no-wrap items-center q-pa-none q-gutter-xs",
                        },
                        [
                          scope.isUploading
                            ? _c("q-spinner", {
                                staticClass: "q-uploader__spinner",
                              })
                            : _vm._e(),
                          _c("div", { staticClass: "col no-margin" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "q-uploader__subtitle inline-block",
                              },
                              [
                                _vm._v(
                                  _vm._s(scope.uploadSizeLabel) +
                                    " / " +
                                    _vm._s(scope.uploadProgressLabel)
                                ),
                              ]
                            ),
                          ]),
                          _vm.editable && _vm.maxFiles > 0
                            ? _c("q-btn", {
                                staticClass: "no-margin",
                                attrs: {
                                  type: "a",
                                  icon: "add",
                                  size: "sm",
                                  round: "",
                                  dense: "",
                                  flat: "",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.openCamera.apply(null, arguments)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.haveImage()
                            ? _c(
                                "q-btn",
                                {
                                  staticClass: "no-margin",
                                  attrs: {
                                    icon: "visibility",
                                    round: "",
                                    dense: "",
                                    flat: "",
                                    size: "sm",
                                  },
                                  on: { click: _vm.allImagePreView },
                                },
                                [
                                  _c("q-tooltip", [
                                    _vm._v("이미지 파일 미리보기"),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.fileList && _vm.fileList.length > 0
                            ? _c(
                                "q-btn",
                                {
                                  staticClass: "no-margin",
                                  attrs: {
                                    icon: "delete_outline",
                                    round: "",
                                    dense: "",
                                    flat: "",
                                    size: "sm",
                                  },
                                  on: { click: _vm.removeAllFiles },
                                },
                                [_c("q-tooltip", [_vm._v("파일 전체 삭제")])],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "list",
                  fn: function (scope) {
                    return [
                      scope.files && scope.files.length > 0
                        ? [
                            _c(
                              "q-list",
                              { attrs: { separator: "" } },
                              _vm._l(scope.files, function (file) {
                                return _c(
                                  "q-item",
                                  { key: file.name },
                                  [
                                    _c(
                                      "q-item-section",
                                      [
                                        _c(
                                          "q-item-label",
                                          {
                                            staticClass: "full-width ellipsis",
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(file.name) + " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "q-item-label",
                                          { attrs: { caption: "" } },
                                          [
                                            _vm._v(
                                              " Status: " +
                                                _vm._s(file.__status) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "q-item-label",
                                          { attrs: { caption: "" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(file.__sizeLabel) +
                                                " / " +
                                                _vm._s(file.__progressLabel) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "empty_dscription" },
                              [_c("q-uploader-add-trigger")],
                              1
                            ),
                          ],
                    ]
                  },
                },
              ],
              null,
              false,
              3077145593
            ),
          }),
          _vm.fileList && _vm.fileList.length > 0
            ? _c(
                "q-list",
                {
                  staticClass: "uploaded-file-list",
                  attrs: { separator: "", bordered: "" },
                },
                _vm._l(_vm.fileList, function (file, idx) {
                  return _c(
                    "q-item",
                    { key: idx },
                    [
                      _c(
                        "q-item-section",
                        [
                          _c(
                            "q-item-label",
                            { staticClass: "table-file-origin-name" },
                            [
                              _c(
                                "span",
                                { staticClass: "table-ellipsis" },
                                [
                                  _vm._v(" " + _vm._s(file.oriFileNm) + " "),
                                  _c(
                                    "q-tooltip",
                                    {
                                      attrs: {
                                        anchor: "bottom left",
                                        self: "top left",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(file.oriFileNm) + " ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "q-item-section",
                        { attrs: { top: "", side: "" } },
                        [
                          _vm.editable
                            ? _c(
                                "q-btn",
                                {
                                  staticClass: "gt-xs",
                                  attrs: {
                                    size: "12px",
                                    flat: "",
                                    dense: "",
                                    round: "",
                                    icon: "delete",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.removeFile(file)
                                    },
                                  },
                                },
                                [_c("q-tooltip", [_vm._v("파일 삭제")])],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm.preview &&
          (_vm.preview.src ||
            (_vm.preview.fileList && _vm.preview.fileList.length > 0))
            ? _c(
                "q-dialog",
                {
                  model: {
                    value: _vm.preview.isShow,
                    callback: function ($$v) {
                      _vm.$set(_vm.preview, "isShow", $$v)
                    },
                    expression: "preview.isShow",
                  },
                },
                [
                  _c(
                    "q-card",
                    { staticClass: "preview-image-card" },
                    [
                      _vm.preview.fileList && _vm.preview.fileList.length > 0
                        ? _c(
                            "q-carousel",
                            {
                              attrs: {
                                swipeable: "",
                                animated: "",
                                thumbnails: "",
                                infinite: "",
                              },
                              on: { transition: _vm.transitionImage },
                              model: {
                                value: _vm.preview.slide,
                                callback: function ($$v) {
                                  _vm.$set(_vm.preview, "slide", $$v)
                                },
                                expression: "preview.slide",
                              },
                            },
                            _vm._l(_vm.preview.fileList, function (file, idx) {
                              return _c("q-carousel-slide", {
                                key: idx,
                                attrs: {
                                  name: file.sysAttachFileId,
                                  "img-src": file.src,
                                },
                              })
                            }),
                            1
                          )
                        : _c("q-img", { attrs: { src: _vm.preview.src } }),
                      _c("q-card-section", [
                        _c("div", { staticClass: "row no-wrap items-center" }, [
                          _c("div", { staticClass: "col text-h6" }, [
                            _vm._v(" " + _vm._s(_vm.preview.oriFileNm) + " "),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-auto text-grey text-caption q-pt-md row no-wrap items-center",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getFileSizeTextByRound(
                                      _vm.preview.fileSize
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isOpenCamera
            ? _c(
                "q-dialog",
                {
                  attrs: { persistent: "", maximized: true },
                  model: {
                    value: _vm.isOpenCamera,
                    callback: function ($$v) {
                      _vm.isOpenCamera = $$v
                    },
                    expression: "isOpenCamera",
                  },
                },
                [
                  _c(
                    "q-card",
                    {
                      staticClass: "preview-image-card",
                      staticStyle: { width: "100% !important" },
                    },
                    [
                      _c(
                        "q-bar",
                        [
                          _c("q-space"),
                          _c("q-btn", {
                            attrs: { dense: "", flat: "", icon: "close" },
                            on: { click: _vm.closeCamera },
                          }),
                        ],
                        1
                      ),
                      _c("q-card-section", [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.camera,
                                    expression: "camera",
                                  },
                                ],
                                staticClass: "cameraselect",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.camera = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", [_vm._v("카메라 선택")]),
                                _vm._l(_vm.devices, function (device, i) {
                                  return _c(
                                    "option",
                                    {
                                      key: device.deviceId,
                                      domProps: { value: device.deviceId },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.changeCameraLabel(device.label, i)
                                        )
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("vue-web-cam", {
                                ref: "webcam",
                                attrs: {
                                  "device-id": _vm.deviceId,
                                  height: "90%",
                                },
                                on: {
                                  started: _vm.onStarted,
                                  stopped: _vm.onStopped,
                                  error: _vm.onError,
                                  cameras: _vm.onCameras,
                                  "camera-change": _vm.onCameraChange,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "popupCameraBtn" },
                            [
                              _c("c-btn", {
                                attrs: {
                                  label: "촬영 후 저장",
                                  icon: "photo_camera",
                                  color: "primary",
                                },
                                on: { btnClicked: _vm.onCapture },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticStyle: { display: "none" } }, [
            _c("input", { ref: "serverImage", attrs: { type: "file" } }),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }